import {
    sign_Report_Request,
    sign_Report_Failure,
    sign_Report_Success,
    change_representativeCmpx_Request,
    set_stimulator_Request,
    save_data_Request,
    change_representativeCmpx_Success,
    set_stimulator_Success,
    save_data_Success,
    change_representativeCmpx_Failure,
    set_stimulator_Failure,
    save_data_Failure
} from "../../actions/actionConstants";

const updateRequestingState = (state, action) => {
    if (state === undefined) {
        return {
            requesting: false,
            error: false
        };
    }
    switch (action.type) {
        case change_representativeCmpx_Request:
        case set_stimulator_Request:
        case save_data_Request:
        case sign_Report_Request:
            return {
                ...state.app.signState,
                requesting: true,
                error: false
            };

        case change_representativeCmpx_Success:
        case set_stimulator_Success:
        case save_data_Success:
        case sign_Report_Success:
            return {
                ...state.app.signState,
                requesting: false,
                error: false
            };
        case change_representativeCmpx_Failure:
        case set_stimulator_Failure:
        case save_data_Failure:
        case sign_Report_Failure:
            return {
                ...state.app.signState,
                requesting: false,
                error: true
            };
        default:
            return state.app.requestingState;
    }
};

export default updateRequestingState;
